import { GetAirportGroupOptionsDocument, GetAirportOptionsDocument } from '@/api/queries';

import { FilterOption } from '@/models/gen/graphql';
import graphApi from '@/api';

const [fetchAirportOptions] = graphApi(GetAirportOptionsDocument);
const [fetchAirportGroupOptions] = graphApi(GetAirportGroupOptionsDocument);

const getAirportOptions = async (groups: boolean = false): Promise<FilterOption[]> => {
  const fn = groups ? fetchAirportGroupOptions : fetchAirportOptions;
  const res = await fn();
  return res?.getFilters?.filters?.[groups ? 'airportGroups' : 'airports'];
};

export default getAirportOptions;
